import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// BKT-1509: avisos de índice vigente aplicado por fallback (BKT-1505). Isolado da tela que o exibe
// para poder migrar para o Mural de Avisos sem retrabalho. O usuário vem do token — nunca enviar usuarioId.
const ENDPOINT = "AvisoIndiceVigente";

// Padroniza o retorno do crudeApiService em { ok, data, message }.
// O helper retorna undefined quando a sessão expira (recarrega a página) e,
// nos erros de POST, a mensagem pode vir como objeto { status, message }.
const normalizarResultado = (promise) =>
    Promise.resolve(promise).then((result) => {
        if (!result)
            return { ok: false, data: null, message: "" };
        const ok = result.status >= 200 && result.status < 300;
        const message = result.message && typeof result.message === "object"
            ? result.message.message
            : result.message;
        return { ok, data: result.data, message: message || "" };
    });

// Descarta itens fora do contrato AvisoIndiceVigenteDto (sem id numérico)
const avisosValidos = (data) =>
    Array.isArray(data)
        ? data.filter(a => a && typeof a.avisoIndiceVigenteId === "number")
        : [];

const listarPendentes = () =>
    normalizarResultado(UseGetApiSimple(ENDPOINT)).then(result => ({
        ...result,
        data: result.ok ? avisosValidos(result.data) : [],
    }));

// Confirma a leitura de todos os avisos exibidos; idempotente no servidor
const confirmarLeitura = (avisoIds) =>
    normalizarResultado(UsePostApi(`${ENDPOINT}/confirmar`, avisoIds));

export { listarPendentes, confirmarLeitura, avisosValidos };
